/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Text_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Paste your deck list here..." |
*
* @param {Deck_Upload_Text_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_text_placeholder = /** @type {((inputs?: Deck_Upload_Text_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Text_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collez votre liste de deck ici...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pegue su lista de deck aquí...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cole sua lista de deck aqui...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incolla qui la lista del tuo deck...")
	return /** @type {LocalizedString} */ ("Paste your deck list here...")
});